export const fullCityName = (cityName, stateName): string => {
  const names: string[] = [cityName]
  if (stateName !== cityName && stateName !== null) {
    names.push(stateName)
  }
  return names.join(', ')
}



// WEBPACK FOOTER //
// ./src/helpers/locationNames.ts